import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateOrUpdateDienstleistungMutation, useDeleteDienstleistungMutation, useGetDienstleistungMutation } from '../../../api/StammdatenAPI';
import { IDienstleistung } from '../../../types/Types';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';

const emptyDto: IDienstleistung = {
  uid: '',
  text: '',
  erledigungsart: 'SOFORT',
  automatisch: false
}

export default function AbzurechnnendeDlDetail() {
  const { t } = useTranslation();

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [daten, setDaten] = useState<IDienstleistung>(emptyDto);

  const [getAuftraggeberAPI] = useGetDienstleistungMutation();

  const [deleteDienstleistungAPI] = useDeleteDienstleistungMutation();
  const [createOrUpdateDienstleistungAPI] = useCreateOrUpdateDienstleistungMutation();

  const navigate = useNavigate();
  const location = useLocation();

  const init = () => {

    if (location.state.view === 'detail') {
      getAuftraggeberAPI(location.state.id)
        .unwrap()
        .then((e) => {
          setDaten(e);
          setLoaded(true);
        })
        .catch((ee) => console.log(ee))

    } else if (location.state.view === 'create') {
      setDaten(emptyDto)
      setLoaded(true);
    }
  }

  const handleDelete = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();
    if (window.confirm('Sind sie sicher den Datensatz löschen zu wollen?')) {
      deleteDienstleistungAPI(daten!.uid).unwrap()
        .then(() => navigate('/admin/dienstleistung/'))
        .catch((ee) => console.log(ee))
    }
  }

  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if (location.state.view === 'detail' || location.state.view === 'create') {

      if (location.state.view === 'detail') {

        createOrUpdateDienstleistungAPI(daten)
          .then(resp => navigate('/admin/dienstleistung/'))
          .catch((ee) => console.log(ee))
      }

      if (location.state.view === 'create') {

        createOrUpdateDienstleistungAPI(daten)
          .then(resp => navigate('/admin/dienstleistung/'))
          .catch((ee) => console.log(ee))
      }

    }
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changeitselect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate("../", {
                relative: "path"
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>

          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Dienstleistung Detail</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          <form onSubmit={handleSubmit} className={styles["wg-detail-form"]} >
            {(isLoaded && daten !== undefined &&
              <>
                <div className={styles['wg-detail-form-ueb']}>
                  <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>{daten?.uid}</span></div>
                  <div style={{ textAlign: "end" }}>{(location.state.view === 'detail' && <button type="button" className={styles["wg-a"]} onClick={handleDelete}><i className="bi bi-trash"></i></button>)}</div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Text</label><input type="text" className={styles['wg-input-text']} name="text" value={daten?.text} onChange={changeit} /></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Automatisch</label>

                    <select name="automatisch" className={styles['wg-input-select']} onChange={changeitselect} value={"" + daten.automatisch}>
                      <option value={""}>-- Bitte auswählen --</option>
                      <option value="true" selected={daten.automatisch === true ? true : false}>JA</option>
                      <option value="false" selected={daten.automatisch === true ? true : false}>Nein</option>
                    </select></div>

                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Erledigungsart</label>
                    <select name="erledigungsart" className={styles['wg-input-select']} onChange={changeitselect} value={"" + daten.erledigungsart}>
                      <option value={""}>-- Bitte auswählen --</option>
                      <option value="MANUELL" selected={daten.erledigungsart === "MANUELL" ? true : false}>MANUELL</option>
                      <option value="SOFORT" selected={daten.erledigungsart === "SOFORT" ? true : false}>SOFORT</option>
                      <option value="AUTOMATISCH" selected={daten.erledigungsart === "AUTOMATISCH" ? true : false}>AUTOMATISCH</option>
                    </select>
                  </div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div style={{ textAlign: "end" }}><input type="submit" value="Speichern" className={styles['wg-btn']} /></div>
                  <div></div>
                </div>

              </>)}
          </form>


        </div>
      </div >
    </>
  );
}